import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }
  getNotification(): Observable<any> {
    return this.http.get<any>(`${environment.url}/notification`);
  }
  getAllNotReadNotification(): Observable<any> {
    return this.http.get<any>(`${environment.url}/notification/no-read`);
  }
  getChatNotification(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/notification/chat`, {'headers': headers});
  }
  getOrderNotification(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/notification/order`, {'headers': headers});
  }
  getUserNotification(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/notification/user`, {'headers': headers});
  }
  getPostNotification(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/notification/post`, {'headers': headers});
  }
  saveNotification(notification: Notification) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/notification`, notification, {'headers': headers});
  }
  markNotificationAsRead(idA: number) {
    return this.http.put<any>(`${environment.url}/notification/read/` + idA, null);
  }

  getNotificationById(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<Notification>(`${environment.url}/notification/` + idA);
  }

  deleteNotification(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/notification/` + idA, {'headers': headers});
  }
}
